<template>
 <v-app style="background-image:linear-gradient(to top, rgb(31, 1, 1), rgb(202 71 71)) !important;">
        <main style="height:100%">
            <v-layout wrap align-center justify-center :style="(ancho < 517) ? 'height:100%' : ''">
                        <v-card :class="(ancho < 517) ? '' : 'login-card rounded-xl'" elevation="0" height="100%" :width="(ancho < 517) ? '100%' : '700'" flat raised>
                            <v-col cols="12" sm="12" md="12">
                                <span class="headline primary--text">CAMBIAR CONTRASEÑA</span>
                            </v-col>
                            <template v-if="cambioExitoso">
                                <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-alert text outlined prominent color="green" type="success">
                                            <span class="title"> CAMBIO DE CONTRASEÑA EXITOSO</span><br>
                                            <span>Ya puede intentar autenticarse con su nueva contraseña</span>
                                        </v-alert>
                                    </v-col>
                                </v-row>
                            </template>
                            <template v-else-if="!respuesta">
                            <v-card-text>
                                <v-form ref="form" align-center  lazy-validation>
                                    <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-text-field type="password" :rules="rules.password" v-model="formUser.password_hash" label="password" outlined required />
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-text-field type="password" :rules="rules.repassword" v-model="formUser.repassword" label="re password" outlined required />
                                        </v-col>
                                    </v-row>
                                </v-container>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <div class="flex-grow-1"></div>
                                <v-btn color="primary darken-1" dark @click="agregar">Guardar</v-btn>
                            </v-card-actions>
                        </template>
                        <template v-else-if="respuesta">
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-alert text outlined prominent color="error" type="error">
                                        <span class="title"> PROBLEMA CON EL CODIGO</span><br>
                                        <span>{{respuesta}}.</span>
                                    </v-alert>
                                 </v-col>
                            </v-row>
                            
                        </template>
                        
                        </v-card>
            </v-layout>
        </main>
    </v-app>
</template>

<script>
export default {
    data() {
        return {
            formUser: {
                //email: "",
                password_hash: "",
                repassword: ""
            },
            cambioExitoso:false,
            ancho: (typeof window !== 'undefined') ? window.outerWidth : 517,
            respuesta: null,
            rules: {
                password: [
                    v => !!v || "requiredo",
                    v =>
                    (v && v.length > 5) || "La contraseña debe tener almenos 6 digitos"
                ],
                repassword: [
                    v => !!v || "requiredo",
                    v =>
                    (v && v.length > 5) || "La contraseña debe tener almenos 6 digitos",
                    v =>
                    (v && v == this.formUser.password_hash) || "Las contraseñas deben ser iguales"
                ],
            },

        }
    },
    mounted: async function() {
    if (typeof window !== 'undefined') {
      window.onresize = () => {
        var widthBrowser = window.outerWidth;
        this.ancho = widthBrowser;
      };
    }
  },
    async created() {
        if (!this.$route.params.token) {
            this.respuesta = "El Token no existe";
        }
        if(!this.respuesta){
            let datosToken = this.$route.params.token.split("|");
            if(datosToken.length!=2){
                this.respuesta = "El Token no cumple con los parametros validos";
            }
            let buff =  Buffer.from(datosToken[1], 'base64');
            datosToken[1] = parseInt(buff.toString('ascii'));
            if(!this.respuesta && isNaN(new Date(datosToken[1]).getTime())){
                this.respuesta = "El token esta vencido";
            }
            if(!this.respuesta && (new Date().getTime() > datosToken[1])){
                this.respuesta = "El token esta vencido";
            }
        }
        
  },
    methods: {
        async agregar() {
            try {
            if (this.formUser.password_hash && this.formUser.repassword) {
                 let data = await this.$apiService.update("sistema/personas/changePassword/"+this.$route.params.token, this.formUser).then(data => data);
                 if(data){
                    this.cambioExitoso = true;
                    this.$swal.fire({
                        title: "Completado!",
                        text: "Cambio de contraseña exitoso",
                        icon: "success",
                        confirmButtonText: "Ok"
                        });
                 }
            }
        } catch (error) {
          console.log(error);
          this.$swal.fire({
            title: "Algo sucedio!",
            text: "contacta con el administrador",
            icon: "error"
          });
        }
        },
    }
}
</script>
<style>
html,
body {
  width: 100%;
  height: 100%;
}

.login-card {
  margin-top: 2% !important;
}

</style>